import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '@nttp/common-service/utility-service';
import { ReferralComponent } from '@pg-app/partner/referral/containers/referral/referral.component';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';

@Component({
  selector: 'np-send-referral',
  templateUrl: './send-referral.component.html',
  styleUrls: ['./send-referral.component.scss']
})
export class SendReferralComponent implements OnInit {
  uploadForm: FormGroup;
  invalidFile = false;
  targetFile: File;
  namePattern = `([A-Za-z0-9\-' ]+)`;
  constructor(
    private fb: FormBuilder,
    private utilityService: UtilityService,
    private dialog: MatDialog,
  ) { }

  get firstNameCtrl(): FormControl {
    return this.uploadForm.get('firstName') as FormControl;
  }

  get lastNameCtrl(): FormControl {
    return this.uploadForm.get('lastName') as FormControl;
  }

  get emailCtrl(): FormControl {
    return this.uploadForm.get('email') as FormControl;
  }

  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      firstName: ['', [Validators.required  , Validators.pattern(this.namePattern), Validators.maxLength(255)]],
      lastName: ['', [Validators.required  , Validators.pattern(this.namePattern), Validators.maxLength(255)]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  sendReferral() {
    this.uploadForm.markAllAsTouched();
    if (!this.uploadForm.valid) {
      return;
    }
    const dialogRef = this.dialog.open(ReferralComponent, {
      data: {
        email: this.uploadForm.get("email").value,
        firstName: this.uploadForm.get("firstName").value,
        lastName: this.uploadForm.get("lastName").value,
        isBulkUpload: false
      },
      width: '80vw',
      maxWidth: '1140px',
      height: '80vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.firstNameCtrl.setValue('');
      this.lastNameCtrl.setValue('');
      this.emailCtrl.setValue('');
      this.uploadForm.markAsUntouched();
    });
  }

  bulkUpdload() { 
    const dialogRef = this.dialog.open(ReferralComponent, {
      data: {
        isBulkUpload: true
      },
      width: '80vw',
      maxWidth: '1140px',
      height: '50vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.firstNameCtrl.setValue('');
      this.lastNameCtrl.setValue('');
      this.emailCtrl.setValue('');
      this.uploadForm.markAsUntouched();
    });
  }
}
